import React from 'react';
import { DisabledCyclePopover } from './DisabledCyclePopover/DisabledCyclePopover';
import { MonthlyPopoverWarning } from './MonthlyPopoverWarning/MonthlyPopoverWarning';
import { RootStore, withInjectedRootStore } from '../../../../providers';
import { observer } from 'mobx-react';
import { CycleDetails } from '../../../../types';
import { PaymentCycle } from '@wix/package-picker-common';

export interface CycleSelectorPopoverProps {
  cycleDetails: CycleDetails;
  isDisabled: boolean;
  rootStore: RootStore;
}

const CycleSelectorPopoverComp: React.FC<CycleSelectorPopoverProps> = observer(
  ({ children, cycleDetails, isDisabled, rootStore }) => {
    const currentCycle = rootStore.appStore.currentCycle;

    if (isDisabled) {
      return (
        <DisabledCyclePopover currentCycle={currentCycle}>
          {children}
        </DisabledCyclePopover>
      );
    }

    if (cycleDetails.cycleId === PaymentCycle.MONTHLY) {
      return (
        <MonthlyPopoverWarning
          currentCycle={currentCycle}
          isInSale={rootStore.appStore.isInSale}
        >
          {children}
        </MonthlyPopoverWarning>
      );
    }

    return <>{children}</>;
  },
);

export const CycleSelectorPopover = withInjectedRootStore(
  CycleSelectorPopoverComp,
);
